import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { DownloadLogsReqData } from "./DownloadLogsReqData";

const ENDPOINT = "/download_logs/if_exist";

export class DownloadLogsIfExistCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: DownloadLogsReqData = null;

    constructor(params: DownloadLogsReqData) {
        super();
        this.responseType = "blob";
        this.params = params;
    }

    public execute(): Promise<AxiosResponse> {
        // console.debug("GetInstallationsCommand.execute() with params: ", this.params);
        return this.executeCommand(this.params);
    }
}
